const SCHEDULE_KIOSKS_KEY = 'schedule-selected-kiosks';

/**
 * Retrieves stored kiosk IDs from localStorage.
 * IDs are stored as a comma-separated string.
 *
 * @returns Array of kiosk IDs, or empty array if nothing is stored
 */
export const getStoredKioskIds = (): string[] => {
  const stored = localStorage.getItem(SCHEDULE_KIOSKS_KEY);

  if (!stored) return [];

  return stored.split(',').filter(Boolean);
};

/**
 * Persists kiosk IDs to localStorage.
 * IDs are stored as a comma-separated string for simple serialization.
 * Removes the storage key entirely when the array is empty.
 *
 * @param ids - Array of kiosk IDs to store
 */
export const setStoredKioskIds = (ids: string[]): void => {
  if (ids.length === 0) {
    localStorage.removeItem(SCHEDULE_KIOSKS_KEY);
  } else {
    localStorage.setItem(SCHEDULE_KIOSKS_KEY, ids.join(','));
  }
};
